$('.gifplayer').gifplayer({ 
  onPlay: function(){

    $('.gifPlay').gifplayer('stop');
    $('.gifPlay').removeClass('gifPlay');
    var clickVar = this;
    setTimeout(function(){ 
      $(clickVar).addClass('gifPlay');
    }, 50);
  },
  onStop: function(){
    $('.gifPlay').removeClass('gifPlay');
  }
});
$('.related-product-slider').slick({
  infinite: true,
  slidesToShow: 3,
  slidesToScroll: 3,
  autoplay: true,
  autoplaySpeed: 4500,
  responsive: [
    {
      breakpoint: 1185,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        infinite: true,
        centerMode: false,
        centerPadding: '0px',
        arrows:false,
        autoplaySpeed: 2500,
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        centerPadding: '0px',
        centerMode: false,
        arrows:false,
        autoplaySpeed: 2500,
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        centerPadding: '0px',
        centerMode: false,
        arrows:false,
        autoplaySpeed: 2500,
      }
    }
  ]
});


$('#nav-1').click(function(){
  $('.nav-btn').removeClass("selected");
  $(this).addClass("selected");
  $('.product-page-nav-content').removeClass("show-nav");
  $('.product-page-description-tab').addClass("show-nav");
});
$('#nav-2').click(function(){
  $('.nav-btn').removeClass("selected");
  $(this).addClass("selected");
  $('.product-page-nav-content').removeClass("show-nav");
  $('.product-page-faq-tab').addClass("show-nav");
});
$('#nav-3').click(function(){
  $('.nav-btn').removeClass("selected");
  $(this).addClass("selected");
  $('.product-page-nav-content').removeClass("show-nav");
  $('.product-page-reviews-tab').addClass("show-nav");
});
$('#nav-4').click(function(){
  $('.nav-btn').removeClass("selected");
  $(this).addClass("selected");
  $('.product-page-nav-content').removeClass("show-nav");
  $('.product-page-install-tab').addClass("show-nav");
});
$('#nav-5').click(function(){
  $('.nav-btn').removeClass("selected");
  $(this).addClass("selected");
  $('.product-page-nav-content').removeClass("show-nav");
  $('.product-page-finish-tab').addClass("show-nav");
});

$('.install-accordion-title').click(function(){
  //   $(this).find('.order-product-content').show();
  if($(this).siblings('.install-accordion-content').hasClass('show')){
    $(this).find('.install-accordion-expand').show(300);
    $(this).find('.install-accordion-hide').hide(300);
    $(this).siblings('.install-accordion-content').hide(300).removeClass('show');
  }
  else{
    $(this).find('.install-accordion-expand').hide(300);
    $(this).find('.install-accordion-hide').show(300);
    $(this).siblings('.install-accordion-content').show(300).addClass('show');
  }
});